<template>
  <div class="form-config-container">
    <el-form label-position="top">
      <el-form-item :label="$t('fm.config.form.labelPosition.title')">
        <el-radio-group v-model="data.labelPosition">
          <el-radio-button label="left">{{ $t('fm.config.form.labelPosition.left') }}</el-radio-button>
          <el-radio-button label="right">{{ $t('fm.config.form.labelPosition.right') }}</el-radio-button>
          <el-radio-button label="top">{{ $t('fm.config.form.labelPosition.top') }}</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('fm.config.form.labelWidth')">
        <el-input-number v-model="data.labelWidth" :min="0" :max="200" :step="10" />
      </el-form-item>

      <el-form-item :label="$t('fm.config.form.size')">
        <el-radio-group v-model="data.size">
          <el-radio-button label="medium">medium</el-radio-button>
          <el-radio-button label="small">small</el-radio-button>
          <el-radio-button label="mini">mini</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="表单显隐规则">
        <el-button @click="visible=true">添加显隐规则</el-button>
      </el-form-item>
    </el-form>
    <el-dialog class="pub_dialog" width="100%" :visible.sync="visible" title="添加显隐规则" :close-on-click-modal="false">
      <field-rule v-if="visible" v-model="data.fieldShowRules" :widgets="widgets" :data="data" />
    </el-dialog>
  </div>
</template>

<script>
import FieldRule from '../FieldRule'
export default {
  components: {FieldRule},
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    widgets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {
  },
  watch: {
    'data.fieldShowRules': function (val) {
      console.log('data.fieldShowRules changed', val)
    },
  },
  methods: {

  },
}
</script>
<style lang="scss" scoped>

.pub_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;

  ::v-deep .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;

    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}

//.fui_dept_check {
//  ::v-deep .el-input__inner {
//    height: 30px;
//  }
//}
</style>
